import {MdExpandLess} from "@react-icons/all-files/md/MdExpandLess";
import {MdExpandMore} from "@react-icons/all-files/md/MdExpandMore";
import React, { useState} from "react";
import classes from './FilterInhoud.module.scss'
import {useTekstClient} from "hooks/useTekstClient";
import {useSetSearchParams} from "hooks/useSetSearchParams";
import {useSearchParams } from 'next/navigation'

const FilterInhoud = () => {
    const [expand, setExpand] = useState(true);
    const {tekst} = useTekstClient()
    const searchParams = useSearchParams()
    const {deleteParams, updateParam} = useSetSearchParams()
    const isReleaseNotes = searchParams.get('inhoud') === 'release'

    const handleClick = (boolean) => {

        if (boolean) {
            deleteParams([ {name: 'typen', value: null}])
            updateParam('inhoud', 'release')
        } else {
            deleteParams([
                {name: 'inhoud', value: null},
                {name: 'prod', value: null},
                {name: 'vers', value: null},
                {name: 'kenmerk', value: null}
            ])
        }
    }


    return <div>
        <b className={`flex items-center cursor-pointer`} onClick={() => setExpand(!expand)}>
            {expand
                ? <MdExpandLess />
                : <MdExpandMore />
            }
            {tekst('pagina:support:kenniscentrum:inhoud:titel')}
        </b>
        {expand &&

            <div className={'ml-3'} style={{position: "relative"}}>
                <div className={classes.kenniscentrumOfReleasenotes}>
                    <span className={!isReleaseNotes ? classes.active : classes.nonActive}
                          onClick={() => { handleClick(false); }}>{tekst('pagina:support:kenniscentrum:inhoud:Artikelen')}</span>
                    <span>/</span>
                    <span className={isReleaseNotes ? classes.active : classes.nonActive}
                          onClick={() => { handleClick(true); }}>{tekst('pagina:support:kenniscentrum:inhoud:Release notes')}</span>
                </div>
            </div>

        }
        <div className={`border-b border-kleur-licht-grijs-blauw pb-[20px] mb-[20px]`}/>
    </div>

}
export default FilterInhoud;